/** Bekannte NFT-Contracts → Kollektionsname (sync mit Backend nftCollectionRegistry) */
export const KNOWN_NFT_COLLECTIONS = new Map([
  ["0x24ee6e8d0ffcca3d73eada5c8585301f2bc10d60", "Thorheads"],
  ["0xff0ffb2167ae0b6a8af185df4cd4fe5f76ad9982", "VeMugs"],
  ["0x61d6e954b90d6506ce6964682744bfc2d51abebd", "Female Goatz NFT"],
  ["0xcb831e98a3ae13b4a124ef8d0088edfee3de0c89", "Mino Mob Legendary"],
]);

export function getNftContractFromTx(tx = {}) {
  return String(
    tx?.nftContract ||
      tx?.nft_contract ||
      tx?.contract ||
      tx?.contractAddress ||
      tx?.contract_address ||
      ""
  )
    .trim()
    .toLowerCase();
}

function isGenericNftName(name) {
  const n = String(name || "").trim().toLowerCase();
  if (!n || n === "—") return true;
  if (n === "nft" || n === "unknown") return true;
  if (/^nft[-\s#]?\d*$/i.test(n)) return true;
  if (/^token\s*id\s*#?\d*$/i.test(n)) return true;
  return false;
}

function extractBaseCollectionName(raw) {
  const s = String(raw || "").trim();
  if (!s || isGenericNftName(s)) return "";

  const hashIdx = s.lastIndexOf("#");
  if (hashIdx > 0) {
    const base = s.slice(0, hashIdx).trim();
    if (base && !isGenericNftName(base)) return base;
  }

  return isGenericNftName(s) ? "" : s;
}

/**
 * Kollektionsname für Anzeige: Felder → Contract-Map.
 * (Kein generisches "NFT" — leer wenn unbekannt.)
 */
export function resolveNftCollectionDisplayName(tx = {}) {
  const fromFields = extractBaseCollectionName(
    tx?.nftName ||
      tx?.nft_name ||
      tx?.name ||
      tx?.collection_name ||
      tx?.collectionName ||
      tx?.relatedMintNftName ||
      tx?.related_mint_nft_name
  );
  if (fromFields) return fromFields;

  const contract = getNftContractFromTx(tx);
  if (contract) {
    const fromMap = KNOWN_NFT_COLLECTIONS.get(contract);
    if (fromMap) return fromMap;
  }

  return "";
}
